'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _totalaudit = require('./totalaudit.component');

var _totalaudit2 = _interopRequireDefault(_totalaudit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var totalauditModule = _angular2.default.module('totalaudit', [_angularUiRouter2.default]).component('totalaudit', _totalaudit2.default);

exports.default = totalauditModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/totalaudit/totalaudit.js